export const CHANNEL_OPTIONS = [
  { key: 'email', text: '邮件', value: 'email', color: '#4285f4' },
  { key: 'test', text: '微信测试号', value: 'test', color: '#2cbb00' },
  {
    key: 'corp_app',
    text: '企业微信应用号',
    value: 'corp_app',
    color: '#5fc9ec',
  },
  { key: 'corp', text: '企业微信群机器人', value: 'corp', color: '#019d82' },
  { key: 'lark', text: '飞书群机器人', value: 'lark', color: '#00d6b9' },
  {
    key: 'lark_app',
    text: '飞书自建应用',
    value: 'lark_app',
    color: '#0d71fe',
  },
  { key: 'ding', text: '钉钉群机器人', value: 'ding', color: '#007fff' },
  { key: 'bark', text: 'Bark App', value: 'bark', color: '#ff3b30' },
  {
    key: 'client',
    text: 'WebSocket 客户端',
    value: 'client',
    color: '#121212',
  },
  {
    key: 'telegram',
    text: 'Telegram 机器人',
    value: 'telegram',
    color: '#29a9ea',
  },
  {
    key: 'discord',
    text: 'Discord 群机器人',
    value: 'discord',
    color: '#404eed',
  },
  {
    key: 'one_bot',
    text: 'OneBot 协议',
    value: 'one_bot',
    color: '#76FF03',
  },
  {
    key: 'custom',
    text: '自定义消息通道',
    value: 'custom',
    color: '#cc33ff',
  },
  {
    key: 'group',
    text: '群组消息',
    value: 'group',
    color: '#FF9800',
  },
  {
    key: 'tencent_alarm',
    text: '腾讯云消息告警',
    value: 'tencent_alarm',
    color: '#00a4ff',
  },
  {
    key: 'none',
    text: '不推送',
    value: 'none',
    color: '#808080',
  },
];
